export const USER_DETAILS_PROVIDER = 'udp';
export const TEXTAREA_FIELD = 'textarea';
export const LIST_FIELD = 'list';
export const CHECKBOX_FIELD = 'checkbox';
export const TEXT_FIELD = 'text';
export const NUMBER_FIELD = 'number';
export const DATE_FIELD = 'date';
export const EMAIL_FIELD = 'email';
export const PASSWORD_FIELD = 'password';